import { throwFriendlyError as throwFriendlyErrorBase } from '@/functional/friendlyErrors'

export function throwFriendlyError(error, { operation = undefined } = {}) {
  console.error(error)
  // throw new FriendlyErrorError(getFriendlyErrors(error, { operation }), {
  //   cause: error,
  // })
  throwFriendlyErrorBase(error, { operation })
}
